export default [
  [
    "",
    "App",
    [
      ["/login", "Consult"],
      ["/consult", "Consult"],
      ["/forms", "Forms"],
      ["/twoFactorAuthPhone", "TwoFactorAuthPhone"],
      ["/twoFactorAuthSubmitCode", "TwoFactorAuthSubmitCode"],
      ["/forgotPassword", "ForgotPassword"],
      ["/passwordReset", "PasswordReset"],
      ["/auth/store", "StoreToken"]
    ]
  ],
  ["*", "NotFound"]
];
